module.exports = __webpack_public_path__ + "static/media/epillax-3.308f8ed4.jpg";